/* Adds the warranty trust strip under page/product/collection titles
   so inner pages carry the same reassurance as the homepage.
   The tick is its own element so it can be gold while the label stays
   quiet - dimming the whole strip washed the tick out to grey. */
(function () {
  var ITEMS = [
    "1 year warranty",
    "Free UK delivery",
    "30-day returns",
    "UK-based support"
  ];

  function build() {
    var d = document.createElement("div");
    d.className = "bsl-page-trust";
    d.innerHTML = ITEMS.map(function (t) {
      return '<span><i aria-hidden="true">✓</i>' + t + "</span>";
    }).join("");
    return d;
  }

  function run() {
    if (document.querySelector(".bsl-page-trust")) return;

    var main = document.getElementById("MainContent");
    if (!main) return;

    var tplAttr = main.getAttribute("data-template") || "";

    /* product pages: drop it under the buy button area */
    if (tplAttr.indexOf("product") > -1) {
      var form =
        main.querySelector('form[action*="/cart/add"]') ||
        main.querySelector("[class*='product-form']");
      if (form && form.parentElement) {
        form.parentElement.insertBefore(build(), form.nextSibling);
        return;
      }
    }

    /* everything else: under the first heading */
    var h1 = main.querySelector("h1");
    if (h1 && h1.parentElement) {
      h1.parentElement.insertBefore(build(), h1.nextSibling);
    }
  }

  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
  document.addEventListener("shopify:section:load", run);
})();

/* ------------------------------------------------------------------
   LOADER for the extra bsl-* scripts on every NON-homepage page.
   Added 27 Sep 2026, generalised 4 Oct 2026.

   The bsl-* scripts on these pages are injected by a Shopify ScriptTag,
   not by layout/theme.liquid, and this app's API token can neither read
   nor create ScriptTags. So a brand-new script has no way to get onto
   product and collection pages on its own. This piggy-backs on
   bsl-pages.js, which the ScriptTag already loads everywhere.

   To ship another new script, add its filename to EXTRAS and bump
   VERSION. Do not add another loader block.

   bsl-heroword.js, bsl-solar.js and bsl-cardimg.js are homepage-only and
   no-op here, which is harmless - they are in the shared list so there is
   one place to maintain, not two. bsl-logomark.js, bsl-fitting.js and
   bsl-zoomfit.js are the mirror image: they no-op on the homepage.

   !! CACHE TRAP, AND IT HAS NOW CAUGHT ME TWICE. Editing a file in EXTRAS
   without bumping VERSION serves the old copy and the edit appears to do
   nothing. The first time cost an hour; the second was a copy change to
   bsl-sameday.js on 4 Oct that silently did not apply. If a change is not
   showing up, check VERSION here and in bsl-homecta.js BEFORE assuming the
   code is wrong. Both files must carry the same VERSION.
   ------------------------------------------------------------------ */
(function () {
  var VERSION = "20261007b";
  var EXTRAS = [
    "bsl-quoteonly.js",
    "bsl-sameday.js",
    "bsl-heroword.js",
    "bsl-logomark.js",
    "bsl-solar.js",
    "bsl-fitting.js",
    "bsl-zoomfit.js",
    "bsl-cardimg.js"
  ];

  var me = document.currentScript;
  if (!me) {
    var all = document.querySelectorAll('script[src*="bsl-pages.js"]');
    me = all[all.length - 1];
  }
  if (!me || !me.src) return;

  var dir = me.src.split("?")[0].replace(/bsl-pages\.js$/, "");

  EXTRAS.forEach(function (file) {
    if (document.querySelector('script[src*="' + file + '"]')) return;
    var s = document.createElement("script");
    s.src = dir + file + "?v=" + VERSION;
    s.defer = true;
    (document.head || document.documentElement).appendChild(s);
  });
})();
